var AppDispatcher = require('../dispatchers/AppDispatcher');
var Constants = require('../constants/Constants');
var Invocation = require('../api/Invocation');

var ServiceActions = {
    changePassword: function (service, newPassword) {
        return Invocation.clientService.changeServicePassword(service, newPassword)
    },

    getServices: function () {
        var UserStore = require('../stores/UserStore');
        var clientId = UserStore.getClientId();

        if (clientId) {
            Invocation.clientService.getServices(clientId);
        }
    },

    upgrade: function (service, plan) {
        AppDispatcher.handleViewAction({
            actionType: Constants.client_service.UPGRADE,
            service: service,
            plan: plan
        })
    }
};
module.exports = ServiceActions;



// WEBPACK FOOTER //
// ./app/actions/ServiceActions.js